import { useIntl } from 'react-intl';
import { Input } from 'semantic-ui-react';
import MaybeTranslation from 'components/MaybeTranslation';
import { StyledModalInput } from './styles';

const ModalInput = ({ name, labelName, error, label, component, ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <StyledModalInput error={error} $labelPresent={label}>
      {typeof labelName === 'string' && (
        <label htmlFor={name}>
          <MaybeTranslation renderedValue={labelName} />
        </label>
      )}
      {component || <Input {...rest} label={label} name={name} />}
      {error && formatMessage({ id: error.translationId })}
    </StyledModalInput>
  );
};

export default ModalInput;
